// extracted by mini-css-extract-plugin
export default {"dropdown":"index_dropdown_iTgMf","icon":"index_icon_yat7n"};